// extracted by mini-css-extract-plugin
export default {"cls1":"j5wZSTPTHsJUWmVYnsOg","cls2":"STDFJyEBTPgV3z2upf13 j5wZSTPTHsJUWmVYnsOg"};